module.exports = __webpack_public_path__ + "media/images/mobile/city_img/b1-8f193625b56d3bf1e8b973b7710b6e89.jpg";